export enum METAL_ABBR {
  PT = 'pt',
  PD = 'pd',
  RH = 'rh',
}
